export enum EPayementMode {
	cash = "cash",
	card = "card",
	check = "check",
	transfer = "transfer",
}
